import { useSessionStorage } from 'react-use';

export function useLatestInvoiceIds() {
    const [latestInvoiceIds, storeLatestInvoiceIds] = useSessionStorage<string[]>('invoice_creation.invoice_ids', []);

    return {
        latestInvoiceIds,
        hasLatestInvoiceIds: latestInvoiceIds.length > 0,
        storeLatestInvoiceIds: storeLatestInvoiceIds,
    };
}
